import { Col, CountrySelect, Form, Row, TextField } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';

const gve = (v: any) => v;

const GeneralForm: React.FunctionComponent = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <Form.Section
        label={formatMessage({ id: 'provider.onboarding.form.general.title' })}
        className="first-section"
      >
        <Form.Field
          name="name"
          label={formatMessage({ id: 'provider.onboarding.form.general.name' })}
          required
        >
          <TextField />
        </Form.Field>
        <Form.Field
          name="webUrl"
          label={formatMessage({ id: 'provider.onboarding.form.general.url' })}
        >
          <TextField />
        </Form.Field>
      </Form.Section>
      <Form.Section label={formatMessage({ id: 'provider.onboarding.form.address.title' })}>
        <Form.Field name="address" label={formatMessage({ id: 'kyc.addressLabel' })} required>
          <TextField autoComplete="street-address" />
        </Form.Field>
        <Row gutter={[16, 0]}>
          <Col xs={12} md={6}>
            <Form.Field name="city" label={formatMessage({ id: 'kyc.cityLabel' })} required>
              <TextField autoComplete="address-line1" />
            </Form.Field>
          </Col>
          <Col xs={12} md={6}>
            <Form.Field name="postCode" label={formatMessage({ id: 'kyc.postalLabel' })} required>
              <TextField autoComplete="postal-code" />
            </Form.Field>
          </Col>
        </Row>
        <Form.Field
          name="country"
          label={formatMessage({ id: 'kyc.countyLabel' })}
          required
          getValueFromEvent={gve}
        >
          <CountrySelect useAuthCountries />
        </Form.Field>
      </Form.Section>
    </>
  );
};

export default GeneralForm;
